<form [formGroup]="form" (ngSubmit)="submit()" class="p-4">
  <!-- LOST REASON -->
  <div class="mb-3">
    <p-inputgroup>
      <p-inputgroup-addon><i class="pi pi-times-circle"></i></p-inputgroup-addon>
      <p-floatlabel variant="on" class="flex-1">
        <p-select
          inputId="lostReason"
          formControlName="lostReason"
          [options]="lostReasons"
          optionLabel="name"
          optionValue="value"
          (onChange)="onLostReasonChange($event)"
          styleClass="w-full"
          [appendTo]="'body'"
        >
          <ng-template #selectedItem let-selected>
            @if (selected) {
              <span>{{ selected.name | translate }}</span>
            }
          </ng-template>
          <ng-template #item let-reason>
            <span>{{ reason.name | translate }}</span>
          </ng-template>
        </p-select>
        <label for="lostReason">{{ "MARK_AS_LOST.LABEL" | translate }} *</label>
      </p-floatlabel>
    </p-inputgroup>
    <app-core-errors [control]="form.get('lostReason')"></app-core-errors>
  </div>

  <!-- OTHER COMMENT -->
  @if (showCommentField()) {
    <div class="mb-3">
      <p-inputgroup>
        <p-inputgroup-addon><i class="pi pi-comment"></i></p-inputgroup-addon>
        <p-floatlabel variant="on" class="flex-1">
          <textarea
            id="lostComment"
            pTextarea
            formControlName="lostComment"
            [rows]="5"
            [autoResize]="true"
            class="w-full"
          ></textarea>
          <label for="lostComment">{{ "MARK_AS_LOST.MESSAGE" | translate }} *</label>
        </p-floatlabel>
      </p-inputgroup>
      <app-core-errors [control]="form.get('lostComment')"></app-core-errors>
    </div>
  }

  <div class="flex justify-content-end gap-2 mt-4">
    <p-button [label]="'MARK_AS_LOST.CANCEL_BTN' | translate" [text]="true" (onClick)="closeDialog()" />
    <p-button type="submit" [label]="'MARK_AS_LOST.CONFIRM_BTN' | translate" [disabled]="form.invalid" />
  </div>
</form>
